import { makeRoute } from '~/utils/route';

import template from './e2e-mf.html';
import controller from './e2e-mf.controller';

export default makeRoute({
	template,
	controller,
	title:      'e2e mf',
	path:       '/e2e/mf',
	onlyDev:    true,
});
